@if (_question(); as question) {
  <div class="question" [class.question--locked]="_answered">
    <p class="question-prompt">{{ question.prompt }}</p>

    <div class="question-options">
      @for (option of question.options; track option.id) {
        <button
          class="question-option"
          [attr.myre-question-option-id]="option.id"
          type="button"
          [class.question-option--selected]="
            _resolvedSelectedId() === option.id
          "
          [disabled]="_locked"
          (click)="_onSelect(option)"
        >
          <span class="question-option-label">{{ option.label }}</span>
          @if (option.description) {
            <span class="question-option-description">
              {{ option.description }}
            </span>
          }
        </button>
      }

      <div
        class="question-free"
        [class.question-free--selected]="_resolvedSelectedId() === freeTextId"
      >
        <input
          #freeInput
          id="chat-question-free-input"
          class="question-free-input"
          type="text"
          [disabled]="_locked"
          [placeholder]="_w.otherAnswerPlaceholder()"
          [value]="_resolvedFreeText()"
          (input)="_freeText.set(freeInput.value)"
          (keydown.enter)="_onSubmitFreeText()"
        />
        <myre-button
          icon="myre-icon-send"
          [ariaLabel]="_w.sendMessage()"
          [disabled]="_locked || !_freeText().trim()"
          (onClick)="_onSubmitFreeText()"
        />
      </div>
    </div>
  </div>
}
